export default __webpack_public_path__ + "images/0x3b475f6f2f41853706afc9fa6a6b8c5df1a2724c.png";